import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/** The pack URL named by ?pack=… in a location search string, or null. */
export function packUrlFromSearch(search) {
  var v = new URLSearchParams(search).get('pack');
  return v ? v : null;
}

/** The test id named by ?test=… — the detail-view deep link. Part of the
 * viewer's URL contract alongside ?pack= (decision 2026-07-07). */
export function testIdFromSearch(search) {
  var v = new URLSearchParams(search).get('test');
  return v ? v : null;
}

/** A GitHub Actions artifact reference (`gh-artifact:` pseudo-scheme). */

var GH_NAME = /^[A-Za-z0-9_.-]+$/;
var GH_ID = /^\d+$/;

/**
 * Parse `gh-artifact:<owner>/<repo>/<artifactId>` — the viewer's pseudo-scheme
 * for packs published as GitHub Actions artifacts (opened via the resolver;
 * see data/gh-artifact.ts). Null for anything else, including malformed refs
 * (which then flow down the ordinary URL path and error honestly there).
 */
export function parseGhArtifact(input) {
  if (!input.startsWith('gh-artifact:')) return null;
  var parts = input.slice('gh-artifact:'.length).split('/');
  if (parts.length !== 3) return null;
  var _parts = _slicedToArray(parts, 3),
    owner = _parts[0],
    repo = _parts[1],
    artifactId = _parts[2];
  if (!GH_NAME.test(owner) || !GH_NAME.test(repo) || !GH_ID.test(artifactId)) {
    return null;
  }
  return {
    owner: owner,
    repo: repo,
    artifactId: artifactId
  };
}
export function formatGhArtifact(ref) {
  return "gh-artifact:".concat(ref.owner, "/").concat(ref.repo, "/").concat(ref.artifactId);
}

/** Which .evidence within a multi-pack artifact to open (?ghEntry=). Rides
 * the URL alongside ?pack= so a chooser pick is reloadable/shareable;
 * url-sync preserves it as an unknown param. */
export function ghEntryFromSearch(search) {
  var v = new URLSearchParams(search).get('ghEntry');
  return v ? v : null;
}
export function writeGhEntryParam(entry) {
  try {
    var url = new URL(window.location.href);
    url.searchParams.set('ghEntry', entry);
    window.history.replaceState(window.history.state, '', url);
  } catch (_unused) {
    /* no history API — the pick still opens, just not deep-linkable */
  }
}
export function clearGhEntryParam() {
  try {
    var url = new URL(window.location.href);
    if (!url.searchParams.has('ghEntry')) return;
    url.searchParams["delete"]('ghEntry');
    window.history.replaceState(window.history.state, '', url);
  } catch (_unused2) {
    /* nothing to clear */
  }
}

/** github.com/{owner}/{repo}/actions/runs/{runId}/artifacts/{artifactId} —
 * what people copy from an Actions run page. */
var GH_ARTIFACT_PAGE = /^\/([A-Za-z0-9_.-]+)\/([A-Za-z0-9_.-]+)\/actions\/runs\/\d+\/artifacts\/(\d+)\/?$/;

/**
 * Normalize user-typed pack input. People paste the *viewer's* URL
 * (`…/?pack=<real-url>`) as often as the pack URL itself — if the input is a
 * URL carrying a `pack` query param, unwrap it and use that value instead.
 * A pasted GitHub artifact PAGE URL is rewritten to the gh-artifact pseudo-
 * scheme so the share link people copy from GitHub just works.
 */
export function normalizePackInput(input) {
  try {
    var url = new URL(input);
    var inner = url.searchParams.get('pack');
    if (inner) return inner;
    if (url.hostname === 'github.com' || url.hostname === 'www.github.com') {
      var m = GH_ARTIFACT_PAGE.exec(url.pathname);
      if (m) {
        return formatGhArtifact({
          owner: m[1],
          repo: m[2],
          artifactId: m[3]
        });
      }
    }
  } catch (_unused3) {
    // not an absolute URL — a relative path like /packs/x.evidence is fine as-is
  }
  return input;
}